import { render, staticRenderFns } from "./scene_banner.vue?vue&type=template&id=c1612478&scoped=true"
import script from "./scene_banner.vue?vue&type=script&lang=js"
export * from "./scene_banner.vue?vue&type=script&lang=js"
import style0 from "./scene_banner.vue?vue&type=style&index=0&id=c1612478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1612478",
  null
  
)

export default component.exports